export const EXAMPLES_COUNTER_PLUS_ONE = 'EXAMPLES_COUNTER_PLUS_ONE';
export const EXAMPLES_COUNTER_MINUS_ONE = 'EXAMPLES_COUNTER_MINUS_ONE';
export const EXAMPLES_COUNTER_RESET = 'EXAMPLES_COUNTER_RESET';
export const EXAMPLES_FETCH_REDDIT_LIST_BEGIN = 'EXAMPLES_FETCH_REDDIT_LIST_BEGIN';
export const EXAMPLES_FETCH_REDDIT_LIST_SUCCESS = 'EXAMPLES_FETCH_REDDIT_LIST_SUCCESS';
export const EXAMPLES_FETCH_REDDIT_LIST_FAILURE = 'EXAMPLES_FETCH_REDDIT_LIST_FAILURE';
export const EXAMPLES_FETCH_REDDIT_LIST_DISMISS_ERROR = 'EXAMPLES_FETCH_REDDIT_LIST_DISMISS_ERROR';
export const EXAMPLES_TESTE_SAGA_BEGIN = 'EXAMPLES_TESTE_SAGA_BEGIN';
export const EXAMPLES_TESTE_SAGA_SUCCESS = 'EXAMPLES_TESTE_SAGA_SUCCESS';
export const EXAMPLES_TESTE_SAGA_FAILURE = 'EXAMPLES_TESTE_SAGA_FAILURE';
export const EXAMPLES_TESTE_SAGA_DISMISS_ERROR = 'EXAMPLES_TESTE_SAGA_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/examples/redux/constants.js